import React, { useEffect, useRef } from 'react';
import { scrollToTop } from '../../../utility/domHelpers';
import './MoveToTop.scss';

const MoveToTop = () => {
  const className = 'c-MoveToTop';

  const iconContainerClass = `${className}__icon-container`;
  const iconContainerVisibleClass = `${iconContainerClass}--visible`;

  const iconContainerRef = useRef(null);
  const minIconVisibilityThreshold = 50;

  const handleScroll = () => {
    try {
      const currentClassList = Array.from(iconContainerRef.current.classList);
      const isIconVisible = currentClassList.includes(
        iconContainerVisibleClass
      );
      const showIcon =
        document.documentElement.scrollTop >= minIconVisibilityThreshold;

      // when user scrolls beyond threshold
      if (!isIconVisible && showIcon) {
        iconContainerRef.current.classList.add(iconContainerVisibleClass);
        return;
      }

      // when user scrolls back above threshold
      if (isIconVisible && !showIcon) {
        iconContainerRef.current.classList.remove(iconContainerVisibleClass);
        return;
      }
    } catch (e) {
      iconContainerRef.current.classList.remove(iconContainerVisibleClass);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <div className={className}>
      <div
        className={iconContainerClass}
        ref={iconContainerRef}
        onClick={scrollToTop}
      >
        <i className="fa fa-chevron-up icon-chevron-up"></i>
      </div>
    </div>
  );
};

export default MoveToTop;
